import dayjs from "dayjs"
import { camelCase } from "src/lib/aikagi"
import { ForCICProps } from "../components/ForCIC"
import { IsNotAgreed, User } from "./ForCIC"

type ErrorMessages = string[]

const validateExaminationInfo = (
  simplifiedExamination: ForCICProps["users"][number]["latest_simplified_examination"]
): ErrorMessages => {
  const messages: ErrorMessages = []
  const s = camelCase(simplifiedExamination)

  if (!s.household) messages.push("世帯構成が未入力です")
  if (!s.firstFurigana) messages.push("名（ふりがな）が未入力です")
  if (!s.lastFurigana) messages.push("氏（ふりがな）が未入力です")
  if (!s.telephoneNumber) messages.push("電話番号が未入力です")
  if (!s.birthday) messages.push("生年月日が未入力です")
  if (!s.postcode) messages.push("郵便番号が未入力です")
  if (!s.job) messages.push("職業が未入力です")
  if (!s.incomeYearly) messages.push("年収が未入力です")

  return messages
}

export const EmergencyMessages = (
  displayedUsers: User[],
  proposals: any,
  searchHouses: any
): string[] => {
  const messages: string[] = []

  for (const user of displayedUsers ?? []) {
    if (IsNotAgreed(user)) {
      messages.push(`【緊急】ID:${user.id}の規約同意が取れていないです！！！`)
    }

    if (user?.last_furigana?.includes(user?.first_furigana)) {
      messages.push(`【警告】${user.id}のカナ姓にカナ名が含まれています`)
    }

    const examinationErrorMessages = validateExaminationInfo(user.latest_simplified_examination)

    if (examinationErrorMessages.length) {
      messages.push(
        `【緊急】ID:${user.id}の審査情報にエラーがあります！！！\n${examinationErrorMessages.join(
          "\n"
        )}`
      )
    }

    const latestSimplifiedExamination = user?.latest_simplified_examination
    const aroundInitialCost = user?.around_initial_cost

    if (latestSimplifiedExamination?.income_yearly > 100000000) {
      messages.push(`【警告】${user.id}の年収が1億円を超えています`)
    }

    if (dayjs(latestSimplifiedExamination?.birthday).isAfter(dayjs().subtract(18, "years"))) {
      messages.push(`【警告】${user.id}の年齢が18歳未満です`)
    }

    if (dayjs(latestSimplifiedExamination?.birthday).isBefore(dayjs().subtract(80, "years"))) {
      messages.push(`【警告】${user.id}の年齢が80歳を超えています`)
    }

    if (typeof aroundInitialCost === "number" && aroundInitialCost > 100000000) {
      messages.push(`【警告】${user.id}の初期費用概算が1億円を超えています`)
    }

    const proposal = proposals?.find((p: any) => Number(p?.user_id) === Number(user?.id))

    const searchHouse = searchHouses?.find(
      (sh: any) => Number(sh?.proposal_id) === Number(proposal?.id)
    )

    if (searchHouse) {
      if (searchHouse?.rent_upper > 100000000) {
        messages.push(`【警告】${user.id}の希望賃料が1億円を超えています`)
      }
    }
  }

  return messages
}
